var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeavySnowShower01 = function SvgHeavySnowShower01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heavy_snow_shower-01_svg2__a",
    x1: 12.3,
    x2: 153.52,
    y1: 154.8,
    y2: 13.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow_shower-01_svg2__a",
    id: "heavy_snow_shower-01_svg2__b",
    x1: 53.88,
    x2: 195.09,
    y1: 196.37,
    y2: 55.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow_shower-01_svg2__a",
    id: "heavy_snow_shower-01_svg2__c",
    x1: 38.19,
    x2: 179.4,
    y1: 180.68,
    y2: 39.47
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow_shower-01_svg2__a",
    id: "heavy_snow_shower-01_svg2__d",
    x1: 24.15,
    x2: 165.37,
    y1: 166.65,
    y2: 25.43
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow_shower-01_svg2__a",
    id: "heavy_snow_shower-01_svg2__e",
    x1: 48.48,
    x2: 189.69,
    y1: 190.97,
    y2: 49.76
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow_shower-01_svg2__a",
    id: "heavy_snow_shower-01_svg2__f",
    x1: 82.57,
    x2: 223.79,
    y1: 225.07,
    y2: 83.85
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow_shower-01_svg2__a",
    id: "heavy_snow_shower-01_svg2__g",
    x1: 66.73,
    x2: 207.95,
    y1: 209.22,
    y2: 68.01
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow_shower-01_svg2__a",
    id: "heavy_snow_shower-01_svg2__h",
    x1: 83.19,
    x2: 224.4,
    y1: 225.68,
    y2: 84.47
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow_shower-01_svg2__a",
    id: "heavy_snow_shower-01_svg2__i",
    x1: 19.92,
    x2: 161.14,
    y1: 162.42,
    y2: 21.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_snow_shower-01_svg2__a",
    id: "heavy_snow_shower-01_svg2__j",
    x1: 71.31,
    x2: 212.53,
    y1: 213.8,
    y2: 72.59
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M144.96 24.83c-2.76 0-5.59.37-8.57 1.14C129.11 10.1 113.54 0 95.96 0 76.49 0 59.42 12.46 53.48 31.01a3.19 3.19 0 0 0 2.06 4.01 3.19 3.19 0 0 0 4.01-2.06C64.64 17.07 79.27 6.38 95.96 6.38c14.83 0 27.99 8.4 34.35 21.65-4.38 2-7.41 4.95-9.26 7.31a3.194 3.194 0 0 0 .53 4.48c.59.46 1.28.68 1.97.68.94 0 1.88-.42 2.51-1.21 1.73-2.19 4.76-5.08 9.39-6.41.02 0 .09-.02.11-.03 3.4-1.11 6.48-1.65 9.41-1.65 16.85 0 30.56 13.71 30.56 30.56s-13.71 30.56-30.56 30.56H47.5c-12.69 0-23.02-10.32-23.02-23.01S34.81 46.29 47.5 46.29c1.87 0 3.83.31 6.16.96 3.05.92 5.88 2.57 7.98 4.65.62.62 1.44.93 2.25.93s1.64-.31 2.26-.94a3.19 3.19 0 0 0-.01-4.51c-2.83-2.81-6.61-5.03-10.66-6.25h-.03s-.02-.01-.03-.01c-2.92-.82-5.44-1.2-7.92-1.2-16.21 0-29.39 13.19-29.39 29.39S31.3 98.7 47.5 98.7h97.47c20.37 0 36.93-16.57 36.93-36.93 0-20.37-16.57-36.94-36.93-36.94",
    style: {
      fill: "url(#heavy_snow_shower-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.58 119.29a2.14 2.14 0 0 0-2.92-.78l-5.94 3.43 1.24-4.64c.31-1.14-.37-2.31-1.51-2.62-1.14-.29-2.31.37-2.62 1.51l-2.35 8.77-4.57 2.64a9.05 9.05 0 0 0-4.35-2.51v-5.19l6.42-6.42c.83-.83.83-2.19 0-3.02s-2.19-.83-3.02 0l-3.4 3.4v-6.95c0-1.18-.96-2.14-2.14-2.14s-2.14.96-2.14 2.14v6.93l-3.4-3.4c-.83-.83-2.19-.83-3.02 0s-.83 2.19 0 3.02l6.42 6.42v5.2a8.96 8.96 0 0 0-4.36 2.51l-4.49-2.59-2.35-8.77a2.14 2.14 0 0 0-2.62-1.51 2.146 2.146 0 0 0-1.51 2.62l1.24 4.64-6.02-3.47a2.14 2.14 0 0 0-2.92.78 2.14 2.14 0 0 0 .78 2.92l6.01 3.47-4.64 1.24a2.146 2.146 0 0 0-1.51 2.62 2.143 2.143 0 0 0 2.62 1.51l8.77-2.35 4.52 2.61c-.23.8-.4 1.64-.4 2.51s.16 1.7.4 2.5l-4.5 2.6-8.77-2.35c-1.14-.29-2.31.37-2.62 1.51-.3 1.14.37 2.31 1.51 2.62l4.64 1.24-6.02 3.47a2.14 2.14 0 0 0-.78 2.92 2.14 2.14 0 0 0 2.92.78l6.01-3.47-1.24 4.64c-.3 1.14.37 2.31 1.51 2.62 1.17.31 2.32-.39 2.62-1.51l2.35-8.77 4.49-2.59a8.96 8.96 0 0 0 4.36 2.51v5.26l-6.42 6.42c-.83.83-.83 2.19 0 3.02s2.19.83 3.02 0l3.4-3.4v6.87c0 1.18.96 2.14 2.14 2.14s2.14-.96 2.14-2.14v-6.86l3.4 3.4c.83.83 2.19.83 3.02 0s.83-2.19 0-3.02l-6.42-6.42v-5.28a9.03 9.03 0 0 0 4.36-2.51l4.55 2.63 2.35 8.77c.3 1.12 1.45 1.82 2.62 1.51a2.146 2.146 0 0 0 1.51-2.62l-1.24-4.64 5.95 3.43c1.02.59 2.33.24 2.92-.78a2.14 2.14 0 0 0-.78-2.92l-5.94-3.43 4.64-1.24a2.146 2.146 0 0 0 1.51-2.62c-.3-1.14-1.47-1.81-2.62-1.51l-8.77 2.35-4.58-2.65c.23-.8.4-1.62.4-2.5s-.17-1.71-.4-2.51l4.57-2.64 8.77 2.35c.19.05.37.07.56.07.94 0 1.81-.63 2.06-1.58.3-1.14-.37-2.31-1.51-2.62l-4.65-1.24 5.95-3.43a2.14 2.14 0 0 0 .78-2.92m-25.14 19.27c-2.61 0-4.73-2.12-4.73-4.73s2.12-4.74 4.73-4.74 4.75 2.13 4.75 4.74-2.13 4.73-4.75 4.73",
    style: {
      fill: "url(#heavy_snow_shower-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.67 157.2a1.89 1.89 0 0 1 0-2.66l11.09-11.09a1.89 1.89 0 0 1 2.66 0c.73.73.73 1.92 0 2.66L64.33 157.2c-.73.73-1.92.73-2.66 0",
    style: {
      fill: "url(#heavy_snow_shower-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.37 158.43a1.89 1.89 0 0 1 0-2.66l11.09-11.09a1.89 1.89 0 0 1 2.66 0c.73.73.73 1.92 0 2.66l-11.09 11.09c-.73.73-1.92.73-2.66 0",
    style: {
      fill: "url(#heavy_snow_shower-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.55 180.9a1.89 1.89 0 0 1 0-2.66l11.09-11.09c.73-.73 1.92-.73 2.66 0s.73 1.92 0 2.66L61.21 180.9c-.73.73-1.92.73-2.66 0",
    style: {
      fill: "url(#heavy_snow_shower-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.48 183.17a1.89 1.89 0 0 1 0-2.66l11.09-11.09a1.89 1.89 0 0 1 2.66 0c.73.73.73 1.92 0 2.66l-11.09 11.09c-.73.73-1.92.73-2.66 0",
    style: {
      fill: "url(#heavy_snow_shower-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.88 122.08a1.89 1.89 0 0 1 0-2.66l11.09-11.09a1.89 1.89 0 0 1 2.66 0c.73.73.73 1.92 0 2.66l-11.09 11.09c-.73.73-1.92.73-2.66 0",
    style: {
      fill: "url(#heavy_snow_shower-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.88 154.99a1.89 1.89 0 0 1 0-2.66l11.09-11.09a1.89 1.89 0 0 1 2.66 0c.73.73.73 1.92 0 2.66l-11.09 11.09c-.73.73-1.92.73-2.66 0",
    style: {
      fill: "url(#heavy_snow_shower-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.44 138.14c1.34 0 2.43-1.09 2.43-2.43v-8.52l8.53 4.92c1.16.67 2.65.27 3.32-.89s.27-2.65-.89-3.32l-8.53-4.92 7.38-4.26c1.16-.67 1.56-2.16.89-3.32a2.434 2.434 0 0 0-3.32-.89l-7.38 4.26v-9.85c0-1.34-1.09-2.43-2.43-2.43s-2.43 1.09-2.43 2.43v9.85l-7.38-4.26a2.434 2.434 0 0 0-3.32.89c-.67 1.16-.27 2.65.89 3.32l7.38 4.26-8.53 4.92a2.434 2.434 0 0 0-.89 3.32 2.434 2.434 0 0 0 3.32.89l8.53-4.92v8.52c0 1.34 1.09 2.43 2.43 2.43",
    style: {
      fill: "url(#heavy_snow_shower-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.36 200c1.34 0 2.43-1.09 2.43-2.43v-8.52l8.53 4.92c1.16.67 2.65.27 3.32-.89s.27-2.65-.89-3.32l-8.53-4.92 7.38-4.26c1.16-.67 1.56-2.16.89-3.32a2.434 2.434 0 0 0-3.32-.89l-7.38 4.26v-9.85c0-1.34-1.09-2.43-2.43-2.43s-2.43 1.09-2.43 2.43v9.85l-7.38-4.26a2.434 2.434 0 0 0-3.32.89c-.67 1.16-.27 2.65.89 3.32l7.38 4.26-8.53 4.92a2.434 2.434 0 0 0-.89 3.32 2.434 2.434 0 0 0 3.32.89l8.53-4.92v8.52c0 1.34 1.09 2.43 2.43 2.43",
    style: {
      fill: "url(#heavy_snow_shower-01_svg2__j)"
    }
  }));
};
export default SvgHeavySnowShower01;